import { range } from "lodash";
import React from "react";
import { Form } from "react-bootstrap";
import { TApiSubsetOptions, TNumberOption } from "../../../../../api/endpoints/SubsetOption";
import EnsembleMembersSelector from "../../../EnsembleMembersSelector";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TNumberOption;
}

export const deriveNumberValuesFromSubsetOption = (number: NonNullable<TApiSubsetOptions['number']>) => {
  const value = number.value.number[0];

  return range(Number(value.from), Number(value.to) + 1, Number(value.by));
}

const EnsembleMembersField = (props: Props) => {
  const { formik, spec } = props;

  return (
    <Form.Group controlId="number">
      <Form.Label>Ensemble members</Form.Label>
      <EnsembleMembersSelector
        values={formik.values.number}
        spec={deriveNumberValuesFromSubsetOption(spec)}
        onChange={values => formik.setFieldValue('number', values)}
      />

      <FormError
        message={formik.errors.number as TFormErrorMessage}
        when={formik.touched.number && Boolean(formik.errors.number)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  )
}

export default EnsembleMembersField;
